
// Constant for managing screen states
export const sc = {
  login: 'login',
  board: 'board',
  endGame: 'endGame'
}
